import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AutoRedactionRule } from '../../../../../models/auto-redaction-rule.model';
import { Presets, PresetType } from '../../../../../models/presets';
import { AutoRedactionService } from '../../../../../services/auto-redaction-service/auto-redaction.service';

@Component({
    selector: 'lex-add-auto-redaction-rule',
    templateUrl: './add-auto-redaction-rule.component.html',
    styleUrls: ['./add-auto-redaction-rule.component.scss'],
    standalone: false
})
export class AddAutoRedactionRuleComponent {
	public hasDuplicateRule: boolean = false;
	public autoRedactionRule: AutoRedactionRule;
	public PresetType = PresetType;
	public presets = new Presets();
	public validationMessage: string;
	private existingRules: string[] = [];
	private initialRule: AutoRedactionRule;

	redactionColors = [
		{ id: '69b9cfdb-6f1a-4631-bb51-d1d5a30ce1aa', name: 'Black', value: '#0c0d01' },
		{ id: 'a2d86281-46c8-4a12-9cf5-f665c5e89e57', name: 'White', value: '#ffffff' }
	];

	constructor(
		private dialogRef: MatDialogRef<AddAutoRedactionRuleComponent>, @Inject(MAT_DIALOG_DATA) data, private service: AutoRedactionService) {
		this.existingRules = data.existingRules;
		this.initialRule = data.autoRedactionRule;
		this.autoRedactionRule = new AutoRedactionRule();
		this.copyOver(this.initialRule, this.autoRedactionRule);
	}

	public validateRule() {
		let isPreset = false;
		this.hasDuplicateRule = this.existingRules.includes(this.autoRedactionRule.rulePattern);

		for (const preset of this.presets.all) {
			if (preset.patternValue == this.autoRedactionRule.rulePattern) {
				this.autoRedactionRule.presetType = preset.type;
				isPreset = true;
			}
		}
		if (!isPreset && this.autoRedactionRule.rulePattern !== '' && this.autoRedactionRule.presetType !== PresetType.customPlainText)
			this.autoRedactionRule.presetType = PresetType.customRegex;
	}

	public setPreset($event) {
		const preset = this.presets.byType($event.value);
		this.autoRedactionRule.rulePattern = preset.patternValue;
		this.autoRedactionRule.ruleTitle = preset.titleSuggestion;
	}

	public ok() {
		this.validateRule();
		if (this.hasDuplicateRule)
			return;

		this.copyOver(this.autoRedactionRule, this.initialRule);

		if (this.initialRule.id) {
			this.service.updateAutoRedactionRule(this.initialRule).subscribe({
				next: (r) => this.dialogRef.close(r),
				error: (httpErrorResponse) => this.validationMessage = httpErrorResponse?.error?.error?.innererror?.message ?? 'Rule failed to validate'
			})
		} else {
			this.service.createAutoRedactionRule(this.initialRule).subscribe({
				next: (r) => this.dialogRef.close(r),
				error: (httpErrorResponse) => this.validationMessage = httpErrorResponse?.error?.error?.innererror?.message ?? 'Rule failed to validate'
			})
		}
	}

	private copyOver(a: AutoRedactionRule, b: AutoRedactionRule) {
		b.ruleTitle = a.ruleTitle;
		b.rulePattern = a.rulePattern;
		b.redactionLabel = a.redactionLabel;
		b.presetType = a.presetType;
		b.redactionColorId = a.redactionColorId;
	}
}
